module.exports = __webpack_public_path__ + "img/main-banner.b1b5ad99.jpg";